import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {DocumentAmendment} from "common/flowmaster/types/amendment";

interface ChatAmendmentGroup {
  conversationItemId: number;
  conversationId: number;
  creationDate: string;
  createdBy: {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
  };
  amendments: DocumentAmendment[];
}

interface IssueChatAmendmentsResponse {
  groups: ChatAmendmentGroup[];
}

export default function fetchIssueChatAmendments(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_CHAT_AMENDMENTS_FETCH,
    (
      organisationId: number,
      projectId: number,
      documentId: number,
      issueId: number,
    ) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/document/${documentId}` +
            `/issue/${issueId}` +
            "/chat-amendments",
          {withCredentials: true},
        )
        .then((response: {data: IssueChatAmendmentsResponse}) => ({
          groups: response.data.groups,
          issueId,
        })),
  );
}
